import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { ODataResourceDataset } from 'app/model/dataset/odata-resource.dataset';
import { IAttribute } from 'app/model/base/annotation';

import { Constants } from 'app/shared/shared-constants';

@Metamodel.model({
    name: adfModelTypeMap.odata.copySourceType,
    display: [],
    tags: {
        datasetModel: Metamodel.modelFor(ODataResourceDataset)
    }
})
export class ODataCopySource extends TabularCopySource {
    public static readonly HTTP_REQUEST_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'HTTP_REQUEST_TIMEOUT',
        display: `${stringResources.ModelName_Request_Timeout}`,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public httpRequestTimeout?: string = '00:05:00';
}
